

































































import { Component, Prop, Vue } from 'vue-property-decorator';

interface ProgressData {
  value: number;
  quantity: number;
}

@Component({
  name: 'damage-status-progress',
})
export default class DamageStatusProgress extends Vue {
  @Prop({ type: Object, required: true })
  newStatus!: ProgressData;

  @Prop({ type: Object, required: true })
  inProgress!: ProgressData;

  @Prop({ type: Object, required: true })
  pending!: ProgressData;

  @Prop({ type: Object, required: true })
  submitted!: ProgressData;

  @Prop({ type: Object, required: true })
  completed!: ProgressData;

  @Prop({ type: Object, required: true })
  declined!: ProgressData;

  @Prop({ type: Object, required: true })
  total!: ProgressData;

  /** Berechnet den Anteil eines Status an der Gesamt-Schadenhöhe. */
  getPercent(part: ProgressData): number {
    if (!this.total.value) {
      return 0;
    }

    const val = (part.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get newPercent() {
    return this.getPercent(this.newStatus);
  }

  get inProgressPercent() {
    return this.getPercent(this.inProgress);
  }

  get pendingPercent() {
    return this.getPercent(this.pending);
  }

  get submittedPercent() {
    return this.getPercent(this.submitted);
  }

  get completedPercent() {
    return this.getPercent(this.completed);
  }

  get declinedPercent() {
    return this.getPercent(this.declined);
  }
}
